import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api'
const MEDIA_BASE_URL = import.meta.env.VITE_MEDIA_URL || 'http://localhost:8000/media'
const API_TIMEOUT = parseInt(import.meta.env.VITE_API_TIMEOUT || '10000')

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: API_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Add auth token if available
    const token = localStorage.getItem('auth_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    
    // Add language parameter to all requests
    const language = localStorage.getItem('language') || 'tr'
    if (config.params) {
      config.params.lang = language
    } else {
      config.params = { lang: language }
    }
    
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    // Handle common errors
    if (error.response?.status === 401) {
      // Unauthorized - redirect to login or clear token
      localStorage.removeItem('auth_token')
    }
    return Promise.reject(error)
  }
)

// Helper function to get full media URL
export const getMediaUrl = (url: string | null | undefined): string | null => {
  if (!url) return null
  
  // If URL is already absolute, return as is
  if (url.startsWith('http')) {
    return url
  }
  
  // If URL starts with /media/, prepend the backend URL
  if (url.startsWith('/media/')) {
    return `${MEDIA_BASE_URL.replace('/media', '')}${url}`
  }
  
  // Otherwise, prepend /media/
  return `${MEDIA_BASE_URL}/${url}`
}

export default api
